import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';
export const ProjectConfigurationListContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    width: 316px;
    overflow-y: auto;
    height: calc(100vh - 161px);
    border-right: solid 1px ${theme.colors.grey[300]};
    box-shadow: 2px 0 4px 0 rgba(0, 0, 0, 0.16);
    background-color: ${theme.colors.white};
  `}
`;

export const ProjectConfigurationName = styled(Box).attrs({
  p: { sm: '600' },
})`
  ${({ theme }) => css`
    border-bottom: solid 1px ${theme.colors.grey[300]};
  `}
`;
export const NewConfigurationItemStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
})`
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 20%);
  background-color: ${({ theme }) => theme.colors.purple['200']};
  border-top: 1px solid ${({ theme }) => theme.colors.grey['200']};
  width: 316px;
  height: 44px;
  padding: 11px;

  cursor: pointer;
`;
